const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
const apiKey = process.env.REACT_APP_API_KEY; 

const API_URL = `${apiEndpoint}?key=${apiKey}`;
console.log('API_URL:', API_URL);


export async function generateresponse(prompt, userInput) {
    
    const payload = {
      contents: [{
        parts: [
          { text: `${prompt}: ${userInput}` }
        ]
      }]
    };
  
    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
  
      if (!response.ok) {
        throw new Error(`API call failed with status: ${response.status}`);
      }
  
      const data = await response.json();
        return data;

    } catch (error) {
      console.error('Error generating content:', error);
      throw error;
    }
  }